import React from "react";
import { Typography, Row, Col, Card, Button } from "antd";
import {
  CalendarOutlined,
  ClockCircleOutlined,
  EnvironmentOutlined,
  WhatsAppOutlined,
} from "@ant-design/icons";
import seminarImage from "../assets/youth.png";

const { Title, Paragraph } = Typography;

const SeminarDetail = () => {
  const cardStyle = {
    textAlign: "center",
    height: "80px",
    width: "95%",
    margin: "0 auto",
    borderRadius: "12px",
    border: "1px solid #ddd",
    backgroundColor: "#fafafa",
    fontWeight: "500",
    fontSize: "16px",
    padding: "10px 8px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transition: "all 0.3s ease",
  };

  return (
    <div
      style={{
        width: "100%",
        backgroundColor: "#fff",
        overflowX: "hidden",
        fontFamily:
          '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial',
      }}
    >
      {/* 🔹 Hero Section */}
      <div
        style={{
          backgroundColor: "#F6E2FF",
          width: "100%",
          padding: "60px 20px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexWrap: "wrap",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            maxWidth: "1100px",
            width: "100%",
            gap: "30px",
            flexWrap: "wrap",
          }}
          className="hero-flex"
        >
          {/* Left Text */}
          <div
            style={{
              flex: 1,
              minWidth: "300px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
            }}
          >
            <Title
              level={1}
              style={{
                color: "#480558",
                fontWeight: 700,
                fontSize: "clamp(28px, 4vw, 42px)",
                marginBottom: "16px",
              }}
            >
              Youth Sports & Nutrition Seminar
            </Title>

            <Paragraph
              style={{
                fontSize: "17px",
                color: "#000",
                lineHeight: "1.6",
                marginBottom: "20px",
              }}
            >
              Empowering young athletes with the right fuel & fitness for optimal
              performance.
            </Paragraph>

            <div style={{ display: "flex", flexDirection: "column", gap: "14px" }}>
              <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                <CalendarOutlined style={{ color: "#480558", fontSize: "18px" }} />
                <Paragraph style={{ margin: 0, color: "#000", fontSize: "15px" }}>
                  Will be announced soon
                </Paragraph>
              </div>

              <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                <ClockCircleOutlined style={{ color: "#480558", fontSize: "18px" }} />
                <Paragraph style={{ margin: 0, color: "#000", fontSize: "15px" }}>
                  ------
                </Paragraph>
              </div>

              <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                <EnvironmentOutlined style={{ color: "#480558", fontSize: "18px" }} />
                <Paragraph style={{ margin: 0, color: "#000", fontSize: "15px" }}>
                  ------
                </Paragraph>
              </div>
            </div>

            <Button
              type="default"
              size="large"
              style={{
                marginTop: "20px",
                backgroundColor: "#fff",
                color: "#919191ff",
                border: "none",
                fontWeight: "500",
                borderRadius: "6px",
                width: "fit-content",
              }}
            >
              Coming Soon
            </Button>
          </div>

          {/* Right Image */}
          <div
            style={{
              flex: 1,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <img
              src={seminarImage}
              alt="Youth Sports Seminar"
              style={{
                width: "100%",
                maxWidth: "450px",
                height: "auto",
                objectFit: "contain",
              }}
            />
          </div>
        </div>
      </div>

      {/* 🔹 Who Should Attend */}
      <div style={{ maxWidth: "1000px", margin: "60px auto", padding: "0 20px" }}>
        <h2
          style={{
            fontSize: "clamp(18px, 3vw, 22px)",
            fontWeight: "600",
            marginBottom: "20px",
          }}
        >
          Who Should Attend
        </h2>

        <Row gutter={[16, 16]} justify="center">
          {[
            "Youth & Athletes",
            "Parents & Guardians",
            "Coaches & Trainers",
            "Nutrition Enthusiasts",
          ].map((item, i) => (
            <Col xs={24} sm={12} md={12} lg={12} key={i}>
              {/* 👈 changed lg to 12 for 2 per row */}
              <Card bordered hoverable={false} style={cardStyle}>
                {item}
              </Card>
            </Col>
          ))}
        </Row>
      </div>

      {/* 🔹 What You Will Learn */}
      <div style={{ maxWidth: "1000px", margin: "0 auto 60px", padding: "0 20px" }}>
        <h2
          style={{
            fontSize: "clamp(18px, 3vw, 22px)",
            fontWeight: "600",
            marginBottom: "20px",
          }}
        >
          What You Will Learn
        </h2>

        <Row gutter={[16, 16]} justify="center">
          {[
            "Energy and Hydration",
            "Balanced Diet for Growth",
            "Mental Focus & Recovery",
            "Safe Training Habits",
          ].map((item, i) => (
            <Col xs={24} sm={12} md={12} lg={12} key={i}>
              {/* 👈 changed lg to 12 for 2 per row */}
              <Card bordered hoverable={false} style={cardStyle}>
                {item}
              </Card>
            </Col>
          ))}
        </Row>
      </div>

      {/* 🔹 Ready to Join */}
      <div
        style={{
          textAlign: "center",
          padding: "40px 20px",
          backgroundColor: "#fafafa",
        }}
      >
        <h2
          style={{
            fontSize: "clamp(18px, 3vw, 22px)",
            fontWeight: "600",
            marginBottom: "10px",
          }}
        >
          Ready to Join?
        </h2>
        <p style={{ color: "#777", marginBottom: "20px" }}>
          Registration not started yet
        </p>
        <Button
          type="default"
          size="large"
          style={{
            backgroundColor: "#fff",
            color: "#919191ff",
            border: "solid 1px #919191ff",
            fontWeight: "500",
            borderRadius: "6px",
          }}
        >
          Coming Soon
        </Button>
      </div>

      {/* 🔹 Responsive CSS */}
      <style>
        {`
          @media (max-width: 768px) {
            .hero-flex {
              flex-direction: column !important;
              text-align: center;
            }
            .hero-flex img {
              margin-top: 30px;
            }
            .hero-flex button {
              align-self: center;
            }
            .ant-card {
              width: 100% !important;
            }
          }
        `}
      </style>
    </div>
  );
};

export default SeminarDetail;
